export const HOME_LICENSES_RI_STRINGS = {
  title: "Let's comply with Rhode Island's rental codes.",
  subtitle:
    'Homes built before 1978 are required to have a valid lead certificate confirming the property is lead-safe. The certificate must be renewed at least every 2 years to stay valid.',

  // Certificate selector
  'certificate.title': 'Your Lead Certificate',
  'certificate.subtitle':
    'Rhode Island accepts two certificates. Tell us which one you have so we can keep it on file.',
  'certificate.conformance_label': 'I have a current lead certificate.',
  'certificate.conformance_sub_label': 'Less Than 2 Years Old',
  'certificate.lead_free_label': 'I have a Certificate of Lead-Free Status.',
  'certificate.none_label': 'I do not have a valid lead certificate.',

  // Shared capture fields
  'certificate.number_label': 'Certificate Number',
  'certificate.issuance_label': 'Date Issued (MM/DD/YYYY)',

  // Variation A · Certificate of Lead Conformance
  'conformance.title': "Upload your certificate and we'll keep it on file.",
  'conformance.subtitle':
    'A Certificate of Lead Conformance (or Lead-Safe Certificate) confirms your home passed a lead hazard mitigation inspection. It stays valid for 2 years from the issue date.',
  'conformance.upload_label': 'Upload Certificate of Lead Conformance',
  // {date} is the derived expiry, two years after the issue date.
  'conformance.valid_until': 'Valid until {date}.',
  'conformance.expired':
    'This certificate expired on {date}. A renewal inspection is required before lease signing — upload a current certificate, or select that you do not have one.',

  // Variation B · Certificate of Lead-Free Status
  'lead_free.title': "Upload your certificate and we'll keep it on file.",
  'lead_free.subtitle':
    'A Certificate of Lead-Free Status means your home is permanently exempt from lead inspections.',
  'lead_free.upload_label': 'Upload Certificate of Lead-Free Status',

  // Variation C · No certificate — blocks the step.
  'none.warning':
    "A current lead certificate is needed in order to sign a lease. We'll schedule a certified Pro to do the inspection and obtain the proper certificate. If any hazards are found, they must be corrected within 30 days before the certificate can be issued.",
  'none.error':
    'A current lead certificate is required before this home can be listed.',

  // Shown instead of the whole capture section for homes built in 1978 or later.
  'exempt.title': 'No lead certificate needed for this home.',
  'exempt.subtitle':
    "Rhode Island's lead certificate requirement applies to rentals built before 1978, so this home is exempt. Nothing is required from you on this step.",
  'exempt.other_exemptions':
    'Other exemptions include housing zoned for residents 62 or older, and seasonal housing rented no more than 100 days per year to the same tenant.',

  // Sidebar tip
  'tip.title': 'Covering Your Bases',
  'tip.description':
    'Getting your lead certificate on file early helps avoid delays when we find a resident for your home. Homes with a current certificate can move to lease signing faster, reducing vacancy.',
  'tip.description_renewal':
    "Once it's on file, we keep track of the 2-year renewal for you, so you stay compliant without watching the calendar.",
};
